import {css} from 'lit'; export default css`:host(.standalone){position:absolute;top:0;left:var(--goto-spacing-04)}img{display:block;height:var(--goto-spacing-06);width:auto}chameleon-goto-logo{--goto-icon-size:var(--goto-layout-05)}`;
    